import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import * as mainTheme from "../../theme";

export const AntSwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 20,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 4,
    color: mainTheme.palette.white,
    "&$checked": {
      transform: "translateX(20px)",
      color: mainTheme.palette.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: mainTheme.palette.gunmetal,
        borderColor: mainTheme.palette.gunmetal,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${mainTheme.palette.wolfGrey}`,
    height: "20px",
    borderRadius: "10px",
    opacity: 1,
    backgroundColor: mainTheme.palette.wolfGrey,
  },
  checked: {},
}))(Switch);
